import { render, staticRenderFns } from "./accsearchList.vue?vue&type=template&id=ffbdc6c4&scoped=true"
import script from "./accsearchList.vue?vue&type=script&lang=js"
export * from "./accsearchList.vue?vue&type=script&lang=js"
import style0 from "./accsearchList.vue?vue&type=style&index=0&id=ffbdc6c4&prod&lang=scss"
import style1 from "./accsearchList.vue?vue&type=style&index=1&id=ffbdc6c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbdc6c4",
  null
  
)

export default component.exports